/**
 * Agent Operator Context Menu Service
 *
 * Handles context menu actions for agent-operator nodes in the Object Explorer.
 */

import type { AgentOperatorNodeMetadata } from '../../explorer/models/nodeTypes';
import { openAgentWorkspace, deleteAgentObject } from './agentContextMenuHelper';

export function executeAgentOperatorContextMenuAction(
  actionId: string,
  metadata: AgentOperatorNodeMetadata,
  callbacks: { onRefresh: () => void },
) {
  const { connectionId, operatorName } = metadata;

  if (actionId === 'edit-operator') {
    openAgentWorkspace(connectionId, 'operators', { type: 'operator', name: operatorName });
  } else if (actionId === 'delete-operator') {
    void deleteAgentObject(
      connectionId, 'Operator', operatorName,
      (args) => window.electronAPI?.jobScheduler?.deleteOperator(args) ?? Promise.resolve({ success: false, error: 'API not available' }),
      callbacks.onRefresh,
    );
  }
}
